import { NAV, SITE, LINKS, SOCIALS } from "../data/content";

export const Footer = () => (
    <footer
        data-testid="site-footer"
        className="relative bg-bh-deep text-white overflow-hidden"
    >
        <div aria-hidden="true" className="absolute inset-0 pattern-star-gold opacity-[0.04]" />
        <div className="relative max-w-[1565px] mx-auto px-6 sm:px-8 pt-16 pb-8">
            <div className="grid md:grid-cols-12 gap-12 pb-14 border-b border-white/10">
                <div className="md:col-span-5">
                    <div className="inline-block bg-white rounded-xl p-3 mb-6">
                        <img
                            src="/assets/logo-web.png"
                            alt="Logo resmi PPTQ Baitul Haq"
                            className="h-14 w-auto"
                            width="56"
                            height="56"
                            loading="lazy"
                        />
                    </div>
                    <p className="font-serif text-xl font-bold">{SITE.fullName}</p>
                    <p className="mt-1 text-sm text-bh-softgold">{SITE.subtitle}</p>
                    <p className="mt-4 text-sm leading-relaxed text-white/60 max-w-sm">
                        {SITE.type} di {SITE.location}. {SITE.tagline}.
                    </p>
                    <p data-testid="footer-nsp" className="mt-4 text-xs uppercase tracking-[0.2em] text-white/50">
                        NSP {SITE.nsp}
                    </p>
                </div>
                <nav aria-label="Navigasi footer" className="md:col-span-3">
                    <p className="text-xs font-semibold uppercase tracking-[0.24em] text-bh-softgold mb-5">
                        Navigasi
                    </p>
                    <ul className="space-y-3">
                        {NAV.map((item) => (
                            <li key={item.id}>
                                <a
                                    href={item.href}
                                    data-testid={`footer-nav-${item.id}`}
                                    className="text-sm text-white/70 hover:text-bh-softgold transition-colors duration-200"
                                >
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div className="md:col-span-4">
                    <p className="text-xs font-semibold uppercase tracking-[0.24em] text-bh-softgold mb-5">
                        Kontak
                    </p>
                    <address className="not-italic space-y-3 text-sm text-white/70 leading-relaxed">
                        <p>
                            RT 02 RW 01 Ds Sukorame, Kec. Gandusari,
                            <br />
                            Kab. Trenggalek, Jawa Timur
                        </p>
                        <p>
                            <a
                                href={LINKS.whatsapp}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-whatsapp"
                                className="hover:text-bh-softgold"
                            >
                                {LINKS.whatsappDisplay}
                            </a>
                        </p>
                        <p>
                            <a
                                href={`mailto:${LINKS.email}`}
                                data-testid="footer-email"
                                className="hover:text-bh-softgold break-all"
                            >
                                {LINKS.email}
                            </a>
                        </p>
                    </address>
                    <ul className="flex gap-3 mt-6">
                        {SOCIALS.map((social) => (
                            <li key={social.label}>
                                <a
                                    href={social.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`footer-social-${social.label.toLowerCase()}`}
                                    aria-label={`${social.label} PPTQ Baitul Haq`}
                                    className="flex items-center justify-center w-10 h-10 rounded-full border border-white/20 text-white/80 transition-colors duration-200 hover:border-bh-gold hover:text-bh-softgold"
                                >
                                    <social.icon className="w-4 h-4" aria-hidden="true" />
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="pt-7 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
                <p data-testid="footer-copyright" className="text-center sm:text-left">
                    <span className="block sm:inline">© 2026 {SITE.fullName}.</span>{" "}
                    <span className="block sm:inline">Seluruh hak cipta dilindungi.</span>
                </p>
                <p className="font-serif italic text-white/60">
                    Mencetak Generasi Qurani Pemimpin Peradaban
                </p>
            </div>
        </div>
    </footer>
);
